import { useEffect, useRef, MutableRefObject } from 'react'

export const useMutationObserver = <T extends HTMLElement>(
  cb: (mutations: MutationRecord[], el: T) => ReturnType<typeof setTimeout>,
  opts: MutationObserverInit
): MutableRefObject<T> => {
  const ref = useRef<T>()
  let observer: MutationObserver
  let timer: ReturnType<typeof setTimeout>

  useEffect(() => {
    if (ref.current) {
      observer = new MutationObserver((mutations) => {
        timer = cb(mutations, ref.current as T)
      })

      observer.observe(ref.current, opts)

      return () => {
        observer.disconnect()
        clearTimeout(timer)
      }
    }
  }, [ref.current])
  return ref as MutableRefObject<T>
}
